import { isLyrraOne } from '@/lib/platform';
import InstitutionSupportsPanel from '@/pages/institution/InstitutionSupportsPanel';
import PodcastsPage from '@/pages/podcasts/PodcastsPage';

/** Contenu de l’onglet « Supports » sous `/dashboard?tab=supports`. */
export function FormateurSupportsTabContent() {
  if (isLyrraOne()) {
    return <PodcastsPage embedded />;
  }
  return <InstitutionSupportsPanel />;
}
